import { render, staticRenderFns } from "./Esterilizacao.vue?vue&type=template&id=6c4f75bf&"
import script from "./Esterilizacao.vue?vue&type=script&lang=js&"
export * from "./Esterilizacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports